import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleUpdateSubmit = async (event) => {
    event.preventDefault();

    const response = await axios.post(
      "/user/update-sign-up-user/",
      JSON.stringify({ email }),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.statusText === "OK") {
      setEmail("");
    }
  };

  return (
    <footer>
      <div className="container-fluid">
        <div className="footer-logo mb-3 text-center">
          <img
            src={`${process.env.PUBLIC_URL}/images/footer-logo.png`}
            width={350}
            alt=""
          />
        </div>
        <div className="row flex-column-reverse flex-md-row">
          <div className="col-md-4 d-none d-md-block">
            <div className="footer-nav">
              <Link to="/action">Action</Link>
              <Link to="/pay">Pay</Link>
            </div>
          </div>
          <div className="col-md-8">
            <div className="row justify-content-end">
              <div className="col-md-4 col-lg-3">
                <div className="widget widget_links text-center text-md-start clearfix my-4 my-md-0 my-xl-0">
                  <h4>CONTACT US</h4>
                  <a
                    href="mailto:hello@beachtoken.io"
                    className="emailus"
                  >
                    hello@beachtoken.io
                  </a>
                </div>
                <div className="foot-signup mt-3 d-md-none">
                  <h3>Sign up for updates</h3>
                  <form onSubmit={handleUpdateSubmit}>
                    <div className="signup_Input">
                      <input
                        type="email"
                        value={email}
                        onChange={(event) => setEmail(event.target.value)}
                        name="email"
                        placeholder="Type email address here..."
                        required
                      />
                      <button type="submit" className="signup_Btn">
                        SIGN UP
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div className="col-md-4 col-lg-3 mt-3 mt-md-0">
                <div className="d-flex justify-content-between d-md-block align-items-center">
                  <div className="footer-nav d-md-none">
                    <Link to="/action">Action</Link>
                    <Link to="/pay">Pay</Link>
                    <Link to="/shop">Shop</Link>
                    <a data-bs-toggle="modal" href="#beach-nomad">
                      Nomad
                    </a>
                    <a data-bs-toggle="modal" href="#beach-farm">
                      Farm
                    </a>
                    <a data-bs-toggle="modal" href="#beach-nft">
                      NFT
                    </a>
                  </div>
                  <div className="widget widget_links clearfix">
                    <ul>
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <a
                          href="/whitepaper/White-Paper.pdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          White Paper
                        </a>
                      </li>
                      <li>
                        <Link to="/tokenomics" target="_blank" rel="noreferrer">
                          Tokenomics
                        </Link>
                      </li>
                      <li>
                        <a
                          href="https://pancakeswap.finance/swap?outputCurrency=0x4f4543Fa5F7FE28a7758ef43FeA71d11fCCDAD5c&chainId=56"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Buy on Pancake Swap
                        </a>
                      </li>
                      <li>
                        <Link to="/blog">Blog</Link>
                      </li>
                      <li>
                        <a
                          href="https://beachcollective.io/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Beach Collective
                        </a>
                      </li>
                      <li>
                        <Link
                          to="/risk-disclosure"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Risk Disclosure
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/privacy"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Privacy
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/terms-and-conditions"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Term and Condition
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-end">
              <div className="col-md-7 col-xl-6 d-none d-md-block">
                <div className="foot-signup py-4">
                  <h3>Sign up for updates</h3>
                  <form onSubmit={handleUpdateSubmit}>
                    <div
                      style={{
                        position: "relative",
                        background: "#fff",
                        borderRadius: "5px",
                      }}
                    >
                      <input
                        type="email"
                        value={email}
                        onChange={(event) => setEmail(event.target.value)}
                        style={{ width: "80%" }}
                        name="email"
                        required
                      />
                      <button
                        type="submit"
                        className="btn btn-outline-blue"
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                        }}
                      >
                        SIGN UP
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div className="col-md-5 col-lg-4 col-xl-3 mt-3 mt-md-0">
                <div className="widget clearfix">
                  <div className="footer-social mt-3">
                    <div className="row m-0">
                      <div className="col-3 mb-2 responsive-0 d-flex justify-content-center align-items-center">
                        <a
                          className="responsive-icon"
                          href="https://t.me/BeachToken"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            className="img-fluid"
                            src={`${process.env.PUBLIC_URL}/images/ic-telegram.png`}
                            alt="Telegram"
                          />
                        </a>
                      </div>
                      <div className="col-3 mb-2 responsive-0 d-flex justify-content-center align-items-center">
                        <a
                          className="responsive-icon"
                          href="https://x.com/bcollective_llc"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            className="img-fluid"
                            src={`${process.env.PUBLIC_URL}/images/ic-twitter2.png`}
                            alt="X"
                          />
                        </a>
                      </div>
                      <div className="col-3 mb-2 responsive-0 d-flex justify-content-center align-items-center">
                        <a
                          className="responsive-icon"
                          href="https://www.instagram.com/beachcollective_llc"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            className="img-fluid"
                            src={`${process.env.PUBLIC_URL}/images/ico-instagram.svg`}
                            alt="Instagram"
                          />
                        </a>
                      </div>
                      <div className="col-3 mb-2 responsive-0 d-flex justify-content-center align-items-center">
                        <a
                          className="responsive-icon"
                          href="https://www.youtube.com/@beachcollective"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            className="img-fluid"
                            src={`${process.env.PUBLIC_URL}/images/ic-YouTube2.png`}
                            alt="YouTube"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
